import { createFileRoute } from '@tanstack/react-router';
import { SettingsPage } from '../components/pages/SettingsPage/SettingsPage';

export const Route = createFileRoute('/account/settings')({
  component: SettingsPage,
});
